<template>
  <div>
    <common-dialog ref="dialog" unit="排产汇总查询" width="1300px" id-key="UserId" @close-saved="$emit('close-saved')" @closed="$emit('onClosed')"
      @details-opened="detailsOpened">
      <template slot="form">
        <el-row style="text-align: center; margin: 15px">
          <el-col :span="6">
            <div>
              <span>日期：</span>
              <el-date-picker
                v-model="ReleaseTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span>加工阶段：{{StageName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button type="primary"  @click="onQuery">查询</el-button>
          </el-col>
        </el-row>
        <el-table ref="table" class="table_bottom table-line tb-c-head" :data="tableData" :row-style="changRed" border>
          <el-table-column prop="ProcessUnitName" label="加工单元" align="center" />
          <el-table-column prop="EquipmentQuantity" label="机台数" min-width="126" align="center" />
          <el-table-column prop="Workload" label="标准产能" min-width="126" align="center" />
          <el-table-column prop="IssuedQuantity" label="已下达数量" min-width="110" align="center" />
          <el-table-column prop="Subtotal" label="小计数量" min-width="110" align="center" />
          <el-table-column prop="IsOverfulfil" label="是否超产" min-width="110" align="center" />
        </el-table>
      </template>

      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      api: require("@/api/production/workDoc").default,
      WorkDocIds:[],
      warehouseList: [],
      tableData: [],
      WarehouseId: null,
      ReleaseTime: this.$commonJs.getToday(),
      total: null,
    };
  },
  props: {
    StageName: {
      type: String,
      default: "",
    }
  },
  methods: {
    changRed({row}) {
    	if (row.IsOverfulfil == "是") { // 变颜色的条件
    		return {
    		color: "red"  // 这个return的就是样式 可以是color 也可以是backgroundColor
    		}
    	}
    },
    detailsOpened() {
      const o = {
        ReleaseTime: this.ReleaseTime,
      }

      this.api.ReviewAlreadySummary(o).then((res) => {
        console.log("ReviewSummary", res);
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });

    },
    onQuery(){
      const o = {
        ReleaseTime: this.ReleaseTime,
      }

      this.api.ReviewAlreadySummary(o).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });
    },
    close() {
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.$refs.dialog.close(true);
    },
  },
};
</script>
<style scoped>
.overfulfil-row {
  color: red;
}
</style>